import { captchaAxios } from 'api/config'
import { AgentInputRequirement } from 'types/agent'
import { store } from 'store'
import { buildAgentInputs } from 'utils/agent-inputs'

export const getAgentsParams = async (chatId: string): Promise<AgentInputRequirement[]> => {
  const { data } = await captchaAxios.get<AgentInputRequirement[]>(`chats/${chatId}/agents/params`)
  return Array.isArray(data) ? data : []
}

export const confirmAgentAction = async ({
  chatId,
  runId,
  approved,
}: {
  chatId: string
  runId: string
  approved: boolean
}): Promise<void> => {
  const inputs = buildAgentInputs(store.getState())
  await captchaAxios.post(`chats/${chatId}/agent/confirm`, { runId, approved, inputs })
}
